module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-32x9-36c363d7527660a1512c14627fd210f9.jpg";